module.exports = __webpack_public_path__ + "img/activity_other8.6387dea3.jpg";